import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'elapsedTime',
  pure: false
})
export class ElapsedTimePipe implements PipeTransform {

  constructor (
    private translate: TranslateService
  ) {

  }

  transform(value: number): unknown {
    if (!value) { 
      return `${this.translate.instant("I18N_MONITORING.LAST_SEEN_A_LONG_TIME_AGO")}`; 
    }
    let time = (Date.now() - value) / 1000;
    if (time < 10) {
      return  `${this.translate.instant("I18N_MONITORING.LAST_SEEN_JUST_NOW")}`;
    }else if (time < 60) {
      return  `${this.translate.instant("I18N_MONITORING.LAST_SEEN_A_MOMENT_AGO")}`;;
    }
    const divider = [60, 60, 24, 30, 12];
   
    let i;
    for (i = 0; Math.floor(time / divider[i]) > 0; i++) {
      time /= divider[i];
    }
    const timeMetrics = ['I18N_DATETIME.SECOND', 'I18N_DATETIME.MINUTE', 'I18N_DATETIME.HOUR', 'I18N_DATETIME.DAY', 'I18N_DATETIME.MONTH', 'I18N_DATETIME.YEAR'].map(metric => {
      return this.translate.instant(Math.floor(time) > 1 ? metric + 'S' : metric)
    });
   
   
    return `${this.translate.instant('I18N_MONITORING.LAST_SEEN_ELAPSED_TIME', { 
      value: Math.floor(time), 
      metric:  timeMetrics[i]
    })}`
  }

}
